import { useContext } from 'react';

import Heading from 'components/common/Heading';
import Subheading from 'components/common/Subheading';
import { UserContext } from 'components/signUpFunnel/Contexts';

const RedesignedThankYouGreeting = ({ firstName = '' }) => {
  const { user } = useContext(UserContext);
  const { weeklyMeals } = user;

  return (
    <div
      className="items-left mx-auto flex w-full max-w-5xl flex-col justify-center gap-4 self-stretch py-8 bp1:items-center bp1:py-10 bp2:text-center"
      data-testid="redesigned-thank-you-greeting"
    >
      <Heading brandStylesOverrides="h1 text-secondary">{`Welcome, ${firstName}!`}</Heading>
      <Subheading className="self-stretch" brandStylesOverrides="textMd bp1:h5 text-secondary">
        {`We picked out ${weeklyMeals} meals for your first box. Take a look and make it yours.`}
      </Subheading>
    </div>
  );
};

RedesignedThankYouGreeting.propTypes = {
  firstName: PropTypes.string,
};

export default RedesignedThankYouGreeting;
